import logo from "./logo.svg";
import "./App.css";
import {
  MDBBadge,
  MDBBtn,
  MDBCheckbox,
  MDBContainer,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBRadio,
  MDBTextArea,
} from "mdb-react-ui-kit";
import { useDispatch, useSelector } from "react-redux";
import { BREAD_PRICE, FLAVOUR_PRICE, INGREDIENTS } from "./constants/Constants";
import { Fragment, useEffect, useState } from "react";
import {
  saveDailyData,
  saveEmployeeName,
  saveOutletName,
  savePhoneNumber,
} from "./config/redux/actions/mainAction";
import toSentenceCase from "./utlis/toSentenceCase";
import Swal from "sweetalert2";
import "moment/locale/id";
import moment from "moment";
import Cookies from "js-cookie";
import request from "./utlis/request";

function App(props) {
  const dispatch = useDispatch();
  const orderList = useSelector((state) => state.main.orderListData);
  const savedPhoneNumber = useSelector((state) => state.main.phoneNumber);
  const employeeName = useSelector((state) => state.main.employeeName);
  const outletName = useSelector((state) => state.main.outletName);
  const [breadSize, setbreadSize] = useState("");
  const [order, setorder] = useState({
    bread: "",
    flavour: "",
    price: 0,
    quantity: 1,
    menu_id: "",
  });
  const [view, setview] = useState("SELL");
  const [allShopping, setallShopping] = useState([]);
  const toggleShow = () => setBasicModal(!basicModal);
  const [basicModal, setBasicModal] = useState(false);
  const toggleShow2 = () => setBasicModal2(!basicModal2);
  const [basicModal2, setBasicModal2] = useState(false);
  const [ingredientsPrice, setingredientsPrice] = useState({ ...INGREDIENTS });
  const [note, setnote] = useState("Tidak ada");
  const [menu, setmenu] = useState([]);
  const [outletData, setoutletData] = useState({
    outlet_name: "",
    address: "",
    join_date: "",
    owner_id: "",
    employee_id: "",
    hpp: 0,
    rent_price_monthly: 0,
  });
  const [stock, setstock] = useState([]);
  const [accessCode, setaccessCode] = useState("");
  const [disableBtnSubmit, setdisableBtnSubmit] = useState(false);

  const onLogout = () => {
    Cookies.remove("employee_id");
    Cookies.remove("outlet_id");
    Cookies.remove("phone_num");
    dispatch(savePhoneNumber(""));
  };

  const onPostLetin = async () => {
    await request.post("/let-in", { access_code: accessCode }).then((res) => {
      if (res.data.code == 200) {
        dispatch(savePhoneNumber(res.data.data.phone_num));
        dispatch(saveEmployeeName(res.data.data.employee_name));
        dispatch(saveOutletName(res.data.data.outlet_name));
        Cookies.set("employee_id", res.data.data.employee_id);
        Cookies.set("outlet_id", res.data.data.outlet_id);
        Cookies.set("phone_num", res.data.data.phone_num);
        onGetOutletProfile(res.data.data.outlet_id);
      } else {
        Swal.fire({
          title: "Eits!",
          text: res.data?.message,
          icon: "warning",
        });
      }
    });
  };

  const onGetMenu = async () => {
    await request.get("/menu").then((res) => {
      if (res.data.code == 200) {
        setmenu(res.data.data);
      }
    });
  };

  const onGetOutletProfile = async (outlet_id) => {
    await request.post("/outlet-profile", { outlet_id }).then((res) => {
      if (res.data.code == 200) {
        setoutletData(res.data.data);
      }
    });
  };

  const onGetStock = async () => {
    await request.get("/stock").then((res) => {
      if (res.data.code == 200) {
        setstock(res.data.data);
      }
    });
  };

  const onPostOrderData = async () => {
    const data = orderList.map((v) => {
      return {
        price_amount: v.amount,
        quantity: v.quantity,
        bread_size: v.bread_size,
        outlet_id: Cookies.get("outlet_id"),
        employee_id: Cookies.get("employee_id"),
        menu_id: v.menu_id,
      };
    });

    // this code written on FE because data is daily, and to make sure data still already there then make calculation easier
    const realBigBreadTotal = data.some((x) => x.bread_size == "price_big")
      ? data
          .filter((v) => v.bread_size == "price_big")
          .map((v) => parseInt(v.quantity))
          .reduce((x, y) => x + y)
      : 0;

    const realSmallBreadTotal = data.some((x) => x.bread_size == "price_small")
      ? data
          .filter((v) => v.bread_size == "price_small")
          .map((v) => parseInt(v.quantity))
          .reduce((x, y) => x + y) / 2
      : 0;

    const totalSales = orderList
      .map((v) => parseInt(v.amount))
      .reduce((x, y) => x + y);
    const totalProductionCost =
      outletData.hpp * (realBigBreadTotal + realSmallBreadTotal);
    const totalProfit = totalSales - totalProductionCost;

    const dataProfit = {
      outlet_id: Cookies.get("outlet_id"),
      daily_real_qty: realBigBreadTotal + realSmallBreadTotal,
      daily_total_sales: totalSales,
      daily_production_cost: totalProductionCost,
      daily_profit: totalProfit,
    };

    try {
      await request.post("/add-transaction", data);
      await request.post("/add-daily-profit", dataProfit).then((res) => {
        if (res.data.code == 200) {
          Swal.fire({
            title: "Okey!",
            text: "Data berhasil disimpan",
            icon: "success",
          });
        }
      });
    } catch (error) {
      let copyData = [...data];
      let copyProfit = { ...dataProfit };
      Swal.fire({
        title: "Oops!",
        text: "Data gagal disimpan",
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "Report error ke Admin",
        showCloseButton: true,
        allowOutsideClick: false,
      }).then((res) => {
        if (res.isConfirmed) {
          window.open(
            `https://api.whatsapp.com/send?phone=6281298698252&text=data${JSON.stringify(
              copyData
            )}profit${JSON.stringify(copyProfit)}`
          );
        }
      });
    }
  };

  const onHandleSetOrder = (e) => {
    let values = JSON.parse(e.target.value);
    let price = values[breadSize];

    if (values.variant_name == "Polos") {
      setbreadSize("price_big");
      price = values.price_big;
    }

    if (values.price_big == null) {
      setbreadSize("price_small");
      price = values.price_small;
    }

    if (values.price_small == null) {
      setbreadSize("price_big");
      price = values.price_big;
    }

    setorder({
      ...order,
      flavour: values.variant_name,
      price,
      menu_id: values.id,
    });
  };

  const onChangeQuantityOrder = (e) => {
    setorder({
      ...order,
      quantity: e.target.value,
    });
  };

  const onHandleSaveOrder = () => {
    if (order.menu_id == "") {
      Swal.fire({
        title: "Eits!",
        text: "Pilih menu terlebih dahulu",
        icon: "warning",
      });
    } else {
      let amount = parseInt(order.price) * parseInt(order.quantity);
      let orderName = `${
        breadSize == "price_small" ? "Roti Kecil" : "Roti Besar"
      } + ${order.flavour}`;
      orderList.push({
        orderName: orderName,
        amount: amount,
        quantity: order.quantity,
        menu_id: order.menu_id,
        bread_size: breadSize,
      });
      dispatch(saveDailyData(orderList));
      setorder({
        bread: "",
        flavour: "",
        price: 0,
        quantity: 1,
      });
      setbreadSize("");
    }
  };

  const onHandlePrintOrder = async () => {
    setdisableBtnSubmit(true);
    let w = moment().format("LLLL");
    let totalAmount = 0;
    let bigBread = { qty: 0, allPrice: 0 };
    let smallBread = { qty: 0, allPrice: 0 };
    let v = orderList.map((v) => {
      totalAmount = parseInt(totalAmount) + v.amount;
      if (v.orderName.includes("Roti Besar")) {
        bigBread = {
          qty: parseInt(bigBread.qty) + parseInt(v.quantity),
          allPrice: parseInt(bigBread.allPrice) + v.amount,
        };
      } else if (v.orderName.includes("Roti Kecil")) {
        smallBread = {
          qty: parseInt(smallBread.qty) + parseInt(v.quantity),
          allPrice: parseInt(smallBread.allPrice) + v.amount,
        };
      }
      return `%0A%2D%20${v.quantity}%20${v.orderName.replace(
        "+",
        "%2B"
      )}%20:%20Rp.%20${v.amount.toLocaleString("ID")}`;
    });

    await onPostOrderData();

    window.open(
      `https://api.whatsapp.com/send?phone=${savedPhoneNumber}&text=${w}%0A%0A•%20Penjualan%0A${v}%0A%0ATotal%20=%20Rp.%20${totalAmount.toLocaleString(
        "ID"
      )}%0A%0ARoti%20Kecil%20:%20${
        smallBread.qty
      }%20(Rp.%20${smallBread.allPrice.toLocaleString(
        "ID"
      )})%0ARoti%20Besar%20:%20${
        bigBread.qty
      }%20(Rp.%20${bigBread.allPrice.toLocaleString(
        "ID"
      )})%0A%0ACatatan%20:%0A${note}`,
      "_blank"
    );
    dispatch(saveDailyData([]));
    toggleShow2();
    setnote("");
    setdisableBtnSubmit(false);
  };

  const onHandlePrintShopping = () => {
    let w = moment().format("LLLL");
    let totalAmount = 0;
    let v = allShopping.map((v) => {
      totalAmount = parseInt(totalAmount) + v.totalPerItem;
      return `%0A%2D%20${v.qty}%20${
        v.name
      }%20:%20Rp.%20${v.totalPerItem.toLocaleString("ID")}`;
    });

    window.open(
      `https://api.whatsapp.com/send?phone=${savedPhoneNumber}&text=${w}%0A%0A•%20Pembelanjaan%0A${v}%0A%0ATotal%20=%20Rp.%20${totalAmount.toLocaleString(
        "ID"
      )}%0A%0ACatatan%20:%0A${note}`,
      "_blank"
    );
    setallShopping([]);
    setingredientsPrice({ ...INGREDIENTS });
    toggleShow();
    setnote("");
  };

  const onHandlPrintShopAndOrder = () => {
    let totalAmount = 0;
    let bigBread = { qty: 0, allPrice: 0 };
    let smallBread = { qty: 0, allPrice: 0 };

    let v = orderList.map((v) => {
      totalAmount = parseInt(totalAmount) + v.amount;
      if (v.orderName.includes("Roti Besar")) {
        bigBread = {
          qty: parseInt(bigBread.qty) + parseInt(v.quantity),
          allPrice: parseInt(bigBread.allPrice) + v.amount,
        };
      } else if (v.orderName.includes("Roti Kecil")) {
        smallBread = {
          qty: parseInt(smallBread.qty) + parseInt(v.quantity),
          allPrice: parseInt(smallBread.allPrice) + v.amount,
        };
      }
      return `%0A%2D%20${v.quantity}%20${v.orderName.replace(
        "+",
        "%2B"
      )}%20:%20Rp.%20${v.amount.toLocaleString("ID")}`;
    });

    let ws = moment().format("LLLL");
    let totalAmountShopping = 0;
    let vs = allShopping.map((v) => {
      totalAmountShopping = parseInt(totalAmountShopping) + v.totalPerItem;
      return `%0A%2D%20${v.qty}%20${
        v.name
      }%20:%20Rp.%20${v.totalPerItem.toLocaleString("ID")}`;
    });

    window.open(
      `https://api.whatsapp.com/send?phone=${savedPhoneNumber}&text=${ws}%0A%0A•%20Pembelanjaan%0A${vs}%0A%0ATotal%20=%20Rp.%20${totalAmountShopping.toLocaleString(
        "ID"
      )}%0A%0A•%20Penjualan%0A${v}%0A%0ATotal%20=%20Rp.%20${totalAmount.toLocaleString(
        "ID"
      )}%0A%0ARoti%20Kecil%20:%20${
        smallBread.qty
      }%20(Rp.%20${smallBread.allPrice.toLocaleString(
        "ID"
      )})%0ARoti%20Besar%20:%20${
        bigBread.qty
      }%20(Rp.%20${bigBread.allPrice.toLocaleString(
        "ID"
      )})%0A%0ACatatan%20:%0A${note}`,
      "_blank"
    );
    dispatch(saveDailyData([]));
    setallShopping([]);
    setingredientsPrice({ ...INGREDIENTS });
    toggleShow2();
    setnote("");
  };

  const onHandleAddShopping = (e, category, name) => {
    let names = e.target.name.includes("_") ? name : e.target.name;
    let values = e.target.value.replace(",", ".");
    setingredientsPrice({
      ...ingredientsPrice,
      [category]: {
        ...ingredientsPrice[category],
        [names]: e.target.value.includes(".")
          ? parseFloat(values)
          : parseInt(values),
      },
    });
  };

  const onHandleResultShopping = () => {
    if (savedPhoneNumber == null || savedPhoneNumber == "") {
      Swal.fire({
        title: "Data tidak bisa diproses",
        text: "Anda belum mengisi nomor handphone",
        icon: "warning",
      });
    } else {
      let allShoppingItem = [];
      Object.entries(ingredientsPrice).map((x, y) => {
        if (x[1].qty != 0) {
          allShoppingItem.push({
            pricePerItem: x[1].price,
            qty: x[1].qty,
            name: x[0],
            totalPerItem: x[1].price * x[1].qty,
          });
        }
      });

      setallShopping(allShoppingItem);
      toggleShow();
    }
  };

  const onHandleDeleteItem = (id) => {
    let val = [...allShopping];
    val.splice(id, 1);
    setallShopping(val);
  };

  const onHandleDeleteOrder = (id) => {
    let val = [...orderList];
    val.splice(id, 1);
    dispatch(saveDailyData(val));
  };

  useEffect(() => {
    onGetMenu();
    onGetStock();
    if (Cookies.get("outlet_id") != "" && Cookies.get("outlet_id") != null) {
      onGetOutletProfile(Cookies.get("outlet_id"));
    }
  }, []);

  return (
    <Fragment>
      <MDBContainer className="pt-1">
        <div className="d-flex justify-content-between gap-2 align-items-center pt-3 pb-2">
          <div className="d-flex align-items-end ms-1">
            <img
              style={{ width: "100px", marginLeft: "-10px" }}
              src="/assets/mimiti.jpeg"
              alt=""
            />
          </div>
          <div>
            <h2 style={{ marginBottom: "-5px" }}>
              {view == "SHOP" ? "Halaman Pembelanjaan" : "Halaman Penjualan"}
            </h2>
            <div className="text-muted">Mimiti Cashier v1.3.0</div>
          </div>
        </div>
        <div style={{ fontSize: "11px" }} className="mb-3">
          {savedPhoneNumber == "" &&
            "Isi kode akses yang telah diberikan oleh pemilik untuk dapat mengakses aplikasi."}
        </div>
        <>
          {savedPhoneNumber ? (
            <span>
              Halo {employeeName}, anda sedang berada di outlet {outletName}.
              Pastikan semua barang dan bahan yang dibutuhkan sudah tersedia.
              Selamat bekerja!
            </span>
          ) : (
            <div className="d-flex gap-2 align-items-center">
              <MDBInput
                placeholder="Masukkan kode akses"
                label="Kode Akses"
                onChange={(e) => setaccessCode(e.target.value.toUpperCase())}
                name="phoneNumber"
                value={accessCode}
                wrapperClass="w-50"
              />
              <MDBBtn
                className="w-50 no-capitalize btn-text"
                onClick={onPostLetin}
              >
                Masuk
              </MDBBtn>
            </div>
          )}
        </>
      </MDBContainer>
      <MDBContainer className="pt-1 pb-5">
        {view == "SHOP" ? (
          <MDBContainer className="mx-0 mt-4">
            {stock.length != 0 && (
              // ***1PEMBELANJAAN*** //
              <>
                {stock.map((v, id) => (
                  <div className="d-flex mb-3" style={{ gap: "10px" }}>
                    <div>{v.ingredient_name}</div>
                    <MDBRadio
                      checked={
                        ingredientsPrice.MARGARIN.qty == 0.5 ? true : false
                      }
                      value={0.5}
                      onClick={(e) => onHandleAddShopping(e, "MARGARIN", "qty")}
                      name="qty_margarin"
                      label="1/2"
                    />
                    <MDBRadio
                      checked={
                        ingredientsPrice.MARGARIN.qty == 0.25 ? true : false
                      }
                      value={0.25}
                      onClick={(e) => onHandleAddShopping(e, "MARGARIN", "qty")}
                      name="qty_margarin"
                      label="1/4"
                    />
                    {/* <div
                  className="d-flex align-items-center"
                  style={{ height: "32px", marginBottom: "30px", gap: "20px" }}
                >
                  <MDBInput
                    onChange={(e) => onHandleAddShopping(e, "TIRAMISU")}
                    name="qty"
                    value={ingredientsPrice.TIRAMISU?.qty}
                    label="Tiramisu"
                    placeholder="Satuan per kg"
                    type="number"
                  />
                  <span>x</span>
                  <MDBInput
                    label="Satuan"
                    onChange={(e) => onHandleAddShopping(e, "TIRAMISU")}
                    name="price"
                    value={ingredientsPrice.TIRAMISU?.price.toLocaleString(
                      "id"
                    )}
                  />
                  <span>/kg</span>
                </div> */}
                  </div>
                ))}
                <MDBBtn
                  className="w-100 no-capitalize btn-text"
                  color="success"
                  onClick={onHandleResultShopping}
                >
                  Simpan &amp; Hitung
                </MDBBtn>
              </>
            )}
            <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
              <MDBModalDialog centered>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Pembelanjaan Hari Ini</MDBModalTitle>
                    <MDBBtn
                      className="btn-close"
                      color="none"
                      onClick={toggleShow}
                    ></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                  >
                    {allShopping.length != 0 ? (
                      allShopping.map((v, id) => {
                        return (
                          <div
                            key={id}
                            className="d-flex justify-content-between align-items-end mb-2"
                          >
                            <div>
                              - {toSentenceCase(v.name.replace("_", " "))}{" "}
                              {v.qty} <br />@ Rp.{" "}
                              {v.totalPerItem.toLocaleString("ID")}
                            </div>
                            <MDBBtn
                              onClick={() => onHandleDeleteItem(id)}
                              color="danger"
                              size="sm"
                            >
                              Hapus
                            </MDBBtn>
                          </div>
                        );
                      })
                    ) : (
                      <>Belum ada data</>
                    )}
                    <p hidden={allShopping.length != 0 ? false : true}>
                      <b>Total</b> : Rp.{" "}
                      {allShopping.length != 0 &&
                        allShopping
                          .map((v) => {
                            return v.totalPerItem;
                          })
                          .reduce((x, y) => x + y)
                          .toLocaleString("ID")}
                    </p>
                    <div className="mt-4 mb-2">
                      <MDBTextArea
                        value={note}
                        onChange={(e) => setnote(e.target.value)}
                        label="Catatan"
                        style={{ color: "black" }}
                      ></MDBTextArea>
                    </div>
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn
                      className="w-100 no-capitalize btn-text"
                      disabled={allShopping.length == 0 ? true : false}
                      color="success"
                      onClick={onHandlePrintShopping}
                    >
                      Kirim Data
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          </MDBContainer>
        ) : (
          // ***2PENJUALAN*** //
          <MDBContainer className="d-flex justify-content-start flex-wrap mx-0 px-0">
            <div className="break"></div>
            <div className="mt-4">
              <p>Ukuran Roti</p>
              <MDBRadio
                checked={breadSize == "price_small" ? true : false}
                onClick={() => setbreadSize("price_small")}
                name="bread"
                value="price_small"
                id="flexCheckDefault"
                label="Kecil"
              />
              <MDBRadio
                checked={breadSize == "price_big" ? true : false}
                onClick={() => setbreadSize("price_big")}
                name="bread"
                value="price_big"
                label="Besar"
              />
            </div>
            <div className="break"></div>
            <div>
              <br />
              <p>Rasa</p>
              <div className="d-flex flex-wrap gap-2">
                {menu.length != 0 ? (
                  menu
                    .sort((a, b) =>
                      a.variant_name.localeCompare(b.variant_name)
                    )
                    .map((v, id) => (
                      <MDBBadge
                        id={id}
                        color={v.bg_color}
                        style={{
                          backgroundColor: v.bg_color,
                          color: v.text_color,
                        }}
                        className="d-flex align-items-center mb-2 p-2 flex-grow-1"
                      >
                        <MDBRadio
                          disabled={breadSize == "" ? true : false}
                          checked={
                            order.flavour == v.variant_name ? true : false
                          }
                          onClick={onHandleSetOrder}
                          name="flavour"
                          value={JSON.stringify(v)}
                        />
                        <span>{v.variant_name}</span>
                      </MDBBadge>
                    ))
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
            <div className="break"></div>
            <div className="mt-4">
              <p>Jumlah pesanan</p>
              <div className="mt-3 d-flex justify-content-between gap-2">
                <MDBInput
                  label="Jumlah"
                  placeholder="1"
                  type="number"
                  value={order.quantity}
                  onChange={onChangeQuantityOrder}
                />
                <MDBBtn
                  className="w-50 no-capitalize btn-text"
                  color="success"
                  onClick={onHandleSaveOrder}
                  disabled={!order.flavour}
                >
                  Tambah data
                </MDBBtn>
              </div>
            </div>
            {/* <div className='w-50'>
                <br />
                <p>Lainnya</p>
                <MDBInput label='Nama Varian' placeholder='Roti kecil + Cokelat + Tiramisu' />
                <br />
                <MDBInput label='Harga' placeholder='25000' type='number' />
              </div> */}
            <div className="break"></div>
            <br />
            <div
              className="d-flex justify-content-between w-100 mt-2"
              style={{ gap: "10px" }}
            >
              <MDBBtn
                className="w-100 no-capitalize btn-text"
                color="primary"
                onClick={() => {
                  if (savedPhoneNumber == null || savedPhoneNumber == "") {
                    Swal.fire({
                      title: "Data tidak bisa diproses",
                      text: "Anda belum mengisi nomor handphone",
                      icon: "warning",
                    });
                  } else {
                    toggleShow2();
                  }
                }}
              >
                Simpan data/Selesai bekerja
              </MDBBtn>
            </div>
            <div className="mt-2 w-100">
              <MDBBtn
                color="light"
                className="w-100 no-capitalize btn-text"
                onClick={() => {
                  Swal.fire({
                    title: "Hapus data",
                    text: "Anda yakin akan hapus seluruh data pembelian di hari ini ?",
                    icon: "warning",
                    cancelButtonText: "Tutup",
                    showCancelButton: true,
                  }).then((res) => {
                    if (res.isConfirmed) {
                      dispatch(saveDailyData([]));
                    }
                  });
                }}
              >
                Reset data
              </MDBBtn>
            </div>
            <div style={{ height: "100%" }} className="w-100 mt-2">
              <MDBBtn
                color="light"
                className="w-100 no-capitalize btn-text"
                onClick={() => {
                  setview("SHOP");
                  setnote("");
                }}
                hidden={view == "SHOP" ? true : false}
              >
                Pembelanjaan
              </MDBBtn>
              <MDBBtn
                color="light"
                className="w-100 no-capitalize btn-text"
                onClick={() => {
                  setview("SELL");
                  setnote("");
                }}
                hidden={view == "SELL" ? true : false}
              >
                Penjualan
              </MDBBtn>
            </div>
            <div className="mt-2 w-100">
              <MDBBtn
                color="danger"
                className="w-100 no-capitalize btn-text"
                onClick={onLogout}
              >
                Keluar
              </MDBBtn>
            </div>
            <MDBModal show={basicModal2} setShow={setBasicModal2} tabIndex="-1">
              <MDBModalDialog centered>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Penjualan Hari Ini</MDBModalTitle>
                    <MDBBtn
                      className="btn-close"
                      color="none"
                      onClick={toggleShow2}
                    ></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                  >
                    {orderList.length != 0 ? (
                      orderList.map((v, id) => {
                        return (
                          <div
                            key={id}
                            className="d-flex justify-content-between align-items-end mb-2"
                          >
                            <div>
                              {v.quantity} {v.orderName} : <br />
                              Rp. {v.amount?.toLocaleString("ID")}
                            </div>
                            <MDBBtn
                              onClick={() => onHandleDeleteOrder(id)}
                              color="danger"
                              size="sm"
                            >
                              Hapus
                            </MDBBtn>
                          </div>
                        );
                      })
                    ) : (
                      <>Belum ada data</>
                    )}
                    <p hidden={orderList.length != 0 ? false : true}>
                      <b>Total</b> = Rp.{" "}
                      {orderList.length != 0 &&
                        orderList
                          .map((v) => {
                            return v.amount;
                          })
                          .reduce((x, y) => x + y)
                          ?.toLocaleString("ID")}
                    </p>
                    <div className="mt-3 mb-2">
                      <MDBTextArea
                        value={note}
                        onChange={(e) => setnote(e.target.value)}
                        label="Catatan"
                        style={{ color: "black" }}
                      ></MDBTextArea>
                    </div>
                  </MDBModalBody>
                  <MDBModalFooter>
                    {/* <MDBBtn
                      className="w-100 no-capitalize btn-text"
                      disabled={
                        orderList.length == 0 && allShopping.length == 0
                          ? true
                          : false
                      }
                      onClick={onHandlPrintShopAndOrder}
                    >
                      Kirim Data Penjualan &amp; Pembelanjaan
                    </MDBBtn> */}
                    <MDBBtn
                      className="w-100 no-capitalize btn-text"
                      disabled={
                        orderList.length == 0 || disableBtnSubmit ? true : false
                      }
                      color="success"
                      onClick={onHandlePrintOrder}
                    >
                      Kirim Data
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          </MDBContainer>
        )}
      </MDBContainer>
    </Fragment>
  );
}

export default App;
